module.exports = "dist/a8e54414a66a5d10bc3d642346b6c1a0.ttf";